import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import { StoreResponse, StoreResponses } from '@/stores/response';
import { productsApi } from '@/stores/api';
import ErrorKey from '@/util/ErrorKey';
import { ProductTuple } from '@/stores/search/util';

@Module({
  namespaced: true,
  name: 'ProductDetailStore',
})
export class ProductDetailStore extends VuexModule {
  public productTuple: ProductTuple | null = null;

  @Action
  public async fetchBySkuAndUnit(
    payload: { sku: string, unitAbbreviation: string },
  ): Promise<StoreResponse<ProductTuple>> {
    const {sku, unitAbbreviation} = payload;
    try {
      const response = await productsApi.getProductBySku('GRM', sku);
      const unit = response.data.units.units
        .find((candidate) => candidate.abbreviation === unitAbbreviation);
      if (!unit) {
        return StoreResponses.forErrorKey(ErrorKey.UnitNotFound, unitAbbreviation);
      }
      const tuple: ProductTuple = {product: response.data, unit};
      this.context.commit('setProductAndUnit', tuple);
      return StoreResponses.success(tuple);
    } catch (e) {
      return StoreResponses.error(e, ErrorKey.ProductDetailFetchAction);
    }
  }

  @Mutation
  private setProductAndUnit(payload: ProductTuple) {
    this.productTuple = payload;
  }
}
